import React from 'react';
import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function MainEventsTable({
  items,
  current,
  pageSize,
  loading,
  total,
  onRowClick,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      pagination={{
        current,
        total,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      scroll={{ x: 1200, y: SCROLL_Y }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { MainEventsTable };
